export default __webpack_public_path__ + "static/media/Blackpink_LE.d64865f9.jpg";